import { useState } from 'react'
import { Link } from '@mui/material'
import { t } from 'i18next'

// import Alert from 'src/components/shared/ui/Alert'
import AlertDialog from 'src/components/shared/ui/AlertDialog/AlertDialog'
import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'
import Container from 'src/components/shared/ui/Container'
import { LEXON_URL } from 'src/config'

import { theme } from 'src/providers/ThemeProvider'

function LexonNotAuthenticated(): JSX.Element {
  const [openAlert, setOpenAlert] = useState(true)

  function close() {
    setOpenAlert(false)
  }

  return (
    <Container>
      {/* <Alert severity="error">
        No has iniciado sesión en Lexon. Por favor, vuelve allí e inicia sesión.
      </Alert> */}

      <AlertDialog
        show={openAlert}
        type={AlertType.ERROR}
        message={
          <>
            Parece que no has iniciado sesión en LexON. Accede a LexON{' '}
            <Link href={LEXON_URL} target="_blank" sx={{ color: theme.colors.byzantineBlue200 }}>
              desde este link
            </Link>{' '}
            e inicia sesión para poder continuar en LexNET.
          </>
        }
        close={close}
        accept={close}
        cancel={close}
        primaryButtonText={t('actions.accept')}
      />
    </Container>
  )
}

export default LexonNotAuthenticated
